import React from 'react'

const Profile = () => {
  return (
    <div>
      User Profile
    </div>
  )
}

export default Profile
